import { Helmet } from "react-helmet-async";
// @mui
import { Grid, Container, Typography } from "@mui/material";
// components
// import Iconify from "../components/iconify";
// sections
import {
  // AppTasks,
  // AppOrderTimeline,
  // AppWebsiteVisits,
  // AppTrafficBySite,
  // AppCurrentSubject,
  // AppConversionRates,
  ActiveMembersBySite,
  AppWidgetSummary,
  ActiveMembersByAgeGroup,
  AppMemberLifecycleTrends,
} from "../sections/@dashboard/app";
import NoSitesYet from "../sections/@dashboard/sites/NoSitesYet";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserData } from "../features/auth/authSlice";
import { setDialog } from "../features/dialog/dialogSlice";
import BirthdayOverview from "../sections/@dashboard/app/BirthdayOverview";
import { useGetDashboardStatsQuery } from "../features/dashboard/dashboardApiSlice";
import useAuth from "../hooks/useAuth";

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const userData = useSelector(selectCurrentUserData);
  const { isAdmin } = useAuth();
  const { data: dashboardStats } = useGetDashboardStatsQuery();

  const dispatch = useDispatch();

  const handleOpenWelcomeDialog = () => {
    dispatch(
      setDialog({
        title: "Willkommen!",
        type: "CREATE",
        content: "welcome",
        data: userData,
      }),
    );
  };

  if (userData && userData.initialLogin) {
    handleOpenWelcomeDialog();
  }

  return (
    <>
      <Helmet>
        <title> MA | Dashboard </title>
      </Helmet>

      <Container maxWidth="">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Willkommen zurück!
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <NoSitesYet />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <BirthdayOverview />
          </Grid>
          {isAdmin && (
            <>
              <Grid item xs={12} md={6} lg={3}>
                <ActiveMembersBySite />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <ActiveMembersByAgeGroup />
              </Grid>
              <Grid item xs={12}>
                <AppMemberLifecycleTrends />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <AppWidgetSummary
                  title="Mitgliedsbeiträge diesen Monat"
                  total={Number(dashboardStats?.monthlyContributions || 0)}
                  icon={"emojione-monotone:euro-banknote"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <AppWidgetSummary
                  title="Neue Mitglieder diesen Monat"
                  total={Number(dashboardStats?.newMembers || 0)}
                  color="info"
                  icon={"mdi:person-multiple-plus"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <AppWidgetSummary
                  title="Kündigungen diesen Monat"
                  total={Number(dashboardStats?.terminatedMembers || 0)}
                  color="error"
                  icon={"mdi:account-cancel"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <AppWidgetSummary
                  title="Veranstaltungen diesen Monat"
                  total={Number(dashboardStats?.monthlyEventsTotal || 0)}
                  color="warning"
                  icon={"mdi:calendar-multiple"}
                />
              </Grid>
            </>
          )}

          {/* 
          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits
              title="Website Visits"
              subheader="(+43%) than last year"
              chartLabels={[
                "01/01/2003",
                "02/01/2003",
                "03/01/2003",
                "04/01/2003",
                "05/01/2003",
                "06/01/2003",
                "07/01/2003",
                "08/01/2003",
                "09/01/2003",
                "10/01/2003",
                "11/01/2003",
              ]}
              chartData={[
                {
                  name: "Team A",
                  type: "column",
                  fill: "solid",
                  data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                },
                {
                  name: "Team B",
                  type: "area",
                  fill: "gradient",
                  data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                },
                {
                  name: "Team C",
                  type: "line",
                  fill: "solid",
                  data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: "Italy", value: 400 },
                { label: "Japan", value: 430 },
                { label: "China", value: 448 },
                { label: "Canada", value: 470 },
                { label: "France", value: 540 },
                { label: "Germany", value: 580 },
                { label: "South Korea", value: 690 },
                { label: "Netherlands", value: 1100 },
                { label: "United States", value: 1200 },
                { label: "United Kingdom", value: 1380 },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={[
                "English",
                "History",
                "Physics",
                "Geography",
                "Chinese",
                "Math",
              ]}
              chartData={[
                { name: "Series 1", data: [80, 50, 30, 40, 100, 20] },
                { name: "Series 2", data: [20, 30, 40, 80, 20, 80] },
                { name: "Series 3", data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(
                () => theme.palette.text.secondary,
              )}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  "1983, orders, $4220",
                  "12 Invoices have been paid",
                  "Order #37745 from September",
                  "New order placed #XF-2356",
                  "New order placed #XF-2346",
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: "FaceBook",
                  value: 323234,
                  icon: (
                    <Iconify
                      icon={"eva:facebook-fill"}
                      color="#1877F2"
                      width={32}
                    />
                  ),
                },
                {
                  name: "Google",
                  value: 341212,
                  icon: (
                    <Iconify
                      icon={"eva:google-fill"}
                      color="#DF3E30"
                      width={32}
                    />
                  ),
                },
                {
                  name: "Linkedin",
                  value: 411213,
                  icon: (
                    <Iconify
                      icon={"eva:linkedin-fill"}
                      color="#006097"
                      width={32}
                    />
                  ),
                },
                {
                  name: "Twitter",
                  value: 443232,
                  icon: (
                    <Iconify
                      icon={"eva:twitter-fill"}
                      color="#1C9CEA"
                      width={32}
                    />
                  ),
                },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>
    </>
  );
}
